import { gql } from 'src/__generated__'

export default gql(`
  mutation removeUser($id: Int!) {
    removeUser(id: $id)
  }
`)
